module.exports = __webpack_public_path__ + "img/cast_ic_forums.a22b028f.svg";